<template>
  <div class="container">
      <div class="title">
          <div>
              <span>发票信息</span>
          </div>
      </div>
      <div class="center">
             <a-table :data-source="invoiceData" bordered :pagination="false">
            <!-- <a-table-column key="index" title="序号" data-index="index" width="70px">
                <template scope="text, record, index">{{ index + 1 }}</template>
            </a-table-column> -->
            <a-table-column  key="goodsType" title="发票代码 * " class="line" data-index="goodsType" >
                <template slot-scope="text, record">
                <a-input v-model="record.name" placeholder="请输入"></a-input>
                </template>
            </a-table-column>
            <a-table-column key="name" title="发票号码 * " class="line" data-index="name">
                <template slot-scope="text, record">
                <a-input v-model="record.name" placeholder="请输入"></a-input>
                </template>
            </a-table-column>
            <a-table-column key="model" title="发票判断" data-index="model">
                <template slot-scope="text, record">
                <a-input v-model="record.name" placeholder="请输入"></a-input>
                </template>
            </a-table-column>
             <a-table-column key="name" title="发票金额（元）" data-index="name">
                <template slot-scope="text, record">
                <a-input v-model="record.name" placeholder="请输入"></a-input>
                </template>
            </a-table-column>
             <a-table-column key="name" title="发票类型" data-index="name">
                <template slot-scope="text, record">
                    <a-select show-search allowClear placeholder="请选择发票类型" class="margin_self" v-model="record.name"
		               @keyup.enter.native="query" style="width: 200px" >
                       <a-select-option :value="item.value" v-for="(item, index) in invoiceList" :key="index">
                          {{ item.title }}
                        </a-select-option>
                    </a-select>
                </template>
            </a-table-column>
             <a-table-column key="name" title="发票附件 *" class="line" data-index="name">
                <template slot-scope="text, record">
                    <a href="#">下载</a>
                    <a-divider type="vertical" />
                    <a href="#">重新上传</a>
                </template>
            </a-table-column>
            <a-table-column key="name" title="操作" data-index="name">
                <template slot-scope="text, record">
                    <a  class="line" href="#">移除</a>
                </template>
            </a-table-column>
        </a-table>
      </div>
       <div class="billBottom">
           <a-button class="addBill" type="dashed" icon="plus" block @click="addCost" > 新增发票 </a-button>
       </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            invoiceData: [{
                name: 1
            }],
            invoiceList: [{
                value: 1,
                title: '电子增值税普通发票',
            },{
                value: 2,
                title: '电子增值税专用发票',
            },{
                value: 3,
                title: '增值税普通发票',
            },{
                value: 4,
                title: '增值税专用发票',
            },
            ]
        }
    }

}
</script>

<style lang="less" scoped>
.container {
    padding-top: 10px;
    .center {
        padding: 10px;
    }
    /deep/ .line{
            color: #f5222d !important;
        }

}
.title {
     font-weight: 700;
    /* float: left; */
    margin-left: 0px;
    color: black;

}
.billBottom {
   display:flex;
   justify-content: center;
  .addBill {
      width: 60%;
      margin-top: 20px;
      border-color: #409EFF !important;
      color: #409EFF !important;
      margin-bottom: 20px;


      &:hover {
        background: #e2f1ff !important;
      }
  }



}

</style>